import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=4b4e713e"
import script from "./ModalContent.ts?vue&type=script&lang=ts&external"
export * from "./ModalContent.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports